export { default } from './TeamChatEntityChip';
